
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    creditorName: String,
    creditorTaxId: String,
    avatarUrl: {
      type: String,
      default: "assets/img/icons/user.svg",
    },
  },
})
export default class CreditorInfo extends Vue {}
